// 아이콘 및 UI 이미지
import orderCompletedIcon from '../assets/icons/common/order_completed.png';
import orderListIcon from '../assets/icons/common/order_list_icon.png';
import bellIcon from '../assets/icons/common/bellicon.png';
import bottomNavBg from '../assets/icons/common/bottomNav.png';
import backIcon from '../assets/icons/common/back_icon.png';
import emptyOrderlistIcon from '../assets/icons/common/empty_orderlist_icon.png';
import trashIcon from '../assets/icons/common/trash_icon.png';
import cartIcon from '../assets/icons/common/cart_icon.png';
import cartNotActiveIcon from '../assets/icons/common/cartnotactiveicon.png';
import languageIcon from '../assets/icons/common/languageicon.png';
import noticeIcon from '../assets/icons/common/noticeicon.png';

// 언어 아이콘
import languageCnIcon from '../assets/icons/language/cn.png';
import languageJaIcon from '../assets/icons/language/ja.png';
import languageEnIcon from '../assets/icons/language/en.png';
import languageKoIcon from '../assets/icons/language/ko.png';

// 관리자 페이지 아이콘
import adminStoreinfoIcon from '../assets/icons/admin/storeinfo.png';
import adminReviewIcon from '../assets/icons/admin/review_icon.png';
import adminArrowIcon from '../assets/icons/admin/arrow.png';
import adminHamburgerIcon from '../assets/icons/admin/hamburger_icon.png';
import adminDeleteIcon from '../assets/icons/admin/delete.png';
import adminModifyIcon from '../assets/icons/admin/modify.png';
import adminModifyPlusIcon from '../assets/icons/admin/modify_plus.png';
import adminDropdownIcon from '../assets/icons/admin/dropdown_icon.png';
import adminExpandIcon from '../assets/icons/admin/expand.png';
import adminCallSettingsIcon from '../assets/icons/admin/call_settings.png';
import adminCategorySettingsIcon from '../assets/icons/admin/category_settings.png';
import adminSyncIcon from '../assets/icons/admin/sync_icon.png';
import adminLogoutIcon from '../assets/icons/admin/logout_icon.png';

// 메뉴 태그 이미지 (다국어별)
import menutagKoreanPopular from '../assets/icons/menutag/korean/popular.png';
import menutagKoreanRecommend from '../assets/icons/menutag/korean/recommend.png';
import menutagKoreanNew from '../assets/icons/menutag/korean/new.png';
import menutagKoreanRequiredTag from '../assets/icons/menutag/korean/requiredTag.png';
import menutagKoreanOptionalTag from '../assets/icons/menutag/korean/optionalTag.png';
import menutagEnglishPopular from '../assets/icons/menutag/english/popular.png';
import menutagEnglishRecommend from '../assets/icons/menutag/english/recommend.png';
import menutagEnglishNew from '../assets/icons/menutag/english/new.png';
import menutagEnglishRequiredTag from '../assets/icons/menutag/english/requiredTag.png';
import menutagEnglishOptionalTag from '../assets/icons/menutag/english/optionalTag.png';
import menutagJapanPopular from '../assets/icons/menutag/japan/popular.png';
import menutagJapanRecommend from '../assets/icons/menutag/japan/recommend.png';
import menutagJapanNew from '../assets/icons/menutag/japan/new.png';
import menutagJapanRequiredTag from '../assets/icons/menutag/japan/requiredTag.png';
import menutagJapanOptionalTag from '../assets/icons/menutag/japan/optionalTag.png';
import menutagChinaPopular from '../assets/icons/menutag/china/popular.png';
import menutagChinaRecommend from '../assets/icons/menutag/china/recommend.png';
import menutagChinaNew from '../assets/icons/menutag/china/new.png';
import menutagChinaRequiredTag from '../assets/icons/menutag/china/requiredTag.png';
import menutagChinaOptionalTag from '../assets/icons/menutag/china/optionalTag.png';

// 오디오
import orderSuccessMp3 from '../assets/audio/order-success.mp3';

// 프로젝트에서 사용되는 모든 이미지 URL 목록
const imageUrls = [
  // 아이콘 및 UI 이미지
  orderCompletedIcon,
  orderListIcon,
  bellIcon,
  bottomNavBg,
  backIcon,
  emptyOrderlistIcon,
  trashIcon,
  cartIcon,
  cartNotActiveIcon,
  languageIcon,
  noticeIcon,

  // 언어 아이콘
  languageCnIcon,
  languageJaIcon,
  languageEnIcon,
  languageKoIcon,

  // 관리자 페이지 아이콘
  adminStoreinfoIcon,
  adminReviewIcon,
  adminArrowIcon,
  adminHamburgerIcon,
  adminDeleteIcon,
  adminModifyIcon,
  adminModifyPlusIcon,
  adminDropdownIcon,
  adminExpandIcon,
  adminCallSettingsIcon,
  adminCategorySettingsIcon,
  adminSyncIcon,
  adminLogoutIcon,

  // 메뉴 태그 이미지 (다국어별)
  menutagKoreanPopular,
  menutagKoreanRecommend,
  menutagKoreanNew,
  menutagKoreanRequiredTag,
  menutagKoreanOptionalTag,
  menutagEnglishPopular,
  menutagEnglishRecommend,
  menutagEnglishNew,
  menutagEnglishRequiredTag,
  menutagEnglishOptionalTag,
  menutagJapanPopular,
  menutagJapanRecommend,
  menutagJapanNew,
  menutagJapanRequiredTag,
  menutagJapanOptionalTag,
  menutagChinaPopular,
  menutagChinaRecommend,
  menutagChinaNew,
  menutagChinaRequiredTag,
  menutagChinaOptionalTag,
];

// 오디오 파일
const audioUrls = [
  orderSuccessMp3
];

// 이미지 프리로드 함수
export const preloadImages = () => {
  const promises = imageUrls.map(url => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        console.log(`Preloaded: ${url.split('/').pop()}`);
        resolve(url);
      };
      img.onerror = () => {
        console.warn(`Failed to preload: ${url}`);
        reject(url);
      };
      img.src = url;
    });
  });

  return Promise.allSettled(promises);
};

// 오디오 프리로드 함수
export const preloadAudio = () => {
  const promises = audioUrls.map(url => {
    return new Promise((resolve, reject) => {
      const audio = new Audio();
      audio.oncanplaythrough = () => {
        console.log(`Preloaded audio: ${url.split('/').pop()}`);
        resolve(url);
      };
      audio.onerror = () => {
        console.warn(`Failed to preload audio: ${url}`);
        reject(url);
      };
      audio.src = url;
      audio.load();
    });
  });

  return Promise.allSettled(promises);
};

// 모든 리소스 프리로드
export const preloadAllResources = async () => {
  console.log('Starting resource preload...');
  const startTime = Date.now();

  try {
    const [imageResults, audioResults] = await Promise.all([
      preloadImages(),
      preloadAudio()
    ]);

    const successfulImages = imageResults.filter(r => r.status === 'fulfilled').length;
    const failedImages = imageResults.filter(r => r.status === 'rejected').length;
    const successfulAudio = audioResults.filter(r => r.status === 'fulfilled').length;
    const failedAudio = audioResults.filter(r => r.status === 'rejected').length;

    const elapsedTime = Date.now() - startTime;

    console.log(`Preload complete in ${elapsedTime}ms`);
    console.log(`   Images: ${successfulImages} loaded, ${failedImages} failed`);
    console.log(`   Audio: ${successfulAudio} loaded, ${failedAudio} failed`);

    return {
      success: true,
      images: { loaded: successfulImages, failed: failedImages },
      audio: { loaded: successfulAudio, failed: failedAudio },
      time: elapsedTime
    };
  } catch (error) {
    console.error('Preload error:', error);
    return {
      success: false,
      error
    };
  }
};

// CSS로 이미지 프리로드 (대체 방법)
export const preloadImagesWithCSS = () => {
  const style = document.createElement('style');
  style.innerHTML = `
    body::after {
      position: absolute;
      width: 0;
      height: 0;
      overflow: hidden;
      z-index: -1;
      content: ${imageUrls.map(url => `url(${url})`).join(' ')};
    }
  `;
  document.head.appendChild(style);
};

// 지연 로딩을 위한 우선순위 설정
export const priorityImageUrls = {
  high: [
    bottomNavBg,
    languageIcon,
    noticeIcon,
  ],
  medium: [
    cartIcon,
    orderListIcon,
    menutagKoreanPopular,
    menutagKoreanRecommend,
    menutagKoreanNew,
    menutagKoreanRequiredTag,
    menutagKoreanOptionalTag,
    adminStoreinfoIcon,
    adminSyncIcon,
    adminLogoutIcon,
    adminArrowIcon,
    adminHamburgerIcon,
    adminDeleteIcon,
    adminModifyIcon,
    adminModifyPlusIcon,
    adminDropdownIcon,
    adminExpandIcon,
    adminCallSettingsIcon,
    adminCategorySettingsIcon,
    adminReviewIcon,
    backIcon,
  ],
  low: [
    orderCompletedIcon,
    emptyOrderlistIcon,
  ]
};

// 우선순위별 프리로드
export const preloadByPriority = async () => {
  await preloadSpecificImages(priorityImageUrls.high);

  setTimeout(() => {
    preloadSpecificImages(priorityImageUrls.medium);
  }, 1000);

  setTimeout(() => {
    preloadSpecificImages(priorityImageUrls.low);
  }, 3000);
};

// 관리자 페이지 아이콘 목록
const adminImageUrls = [
  adminStoreinfoIcon,
  adminSyncIcon,
  adminLogoutIcon,
  adminArrowIcon,
  adminHamburgerIcon,
  adminDeleteIcon,
  adminModifyIcon,
  adminModifyPlusIcon,
  adminDropdownIcon,
  adminExpandIcon,
  adminCallSettingsIcon,
  adminCategorySettingsIcon,
  adminReviewIcon,
  backIcon,
];

// 관리자 페이지 아이콘 즉시 프리로드
export const preloadAdminImages = () => {
  return preloadSpecificImages(adminImageUrls);
};

// 특정 이미지만 프리로드
const preloadSpecificImages = (urls) => {
  return Promise.all(urls.map(url => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(url);
      img.onerror = () => resolve(url);
      img.src = url;
    });
  }));
};
